var YouLi = YouLi ? YouLi : {};
YouLi.Trip = YouLi.Trip ? YouLi.Trip : {};
YouLi.Trip.Invitees = YouLi.Trip.Invitees ? YouLi.Trip.Invitees : {};

(function (YouLi) {
    (function (Trip) {
        (function (Invitees) {

            RefreshFiltersForCategory = function (category) {
                const tripId = $("#TripId").val();
                const inviteeId = $("#InviteeId").val();
                const previewMode = $("#PreviewMode").val();

                YouLi.Common.Get({
                    url: '/trip/updateinviteefiltersforcategory',
                    params: {
                        tripid: tripId,
                        inviteeId: inviteeId,
                        category: category,
                        preview: previewMode
                    },
                }).then(data => {
                    $("#InviteesListFilters").html(data.inviteesListFiltersHtml);
                });
            };

            SearchInvitees = function () {

                const tripId = $("#TripId").val();
                const inviteeId = $("#InviteeId").val();
                const previewMode = $("#PreviewMode").val();
                
                const category = $("#InviteesListCategory").length == 1 ? $("#InviteesListCategory").val() : "";

                const searchTerm = $("#InviteesListSearchTerm").val();

                let requestData = {
                    tripid: tripId,
                    inviteeId: inviteeId,
                    preview: previewMode,
                    searchTerm: searchTerm,
                    category: category
                };

                // Add filters if and only if they have been setup
                if ($("#Filter1TaskItemFieldId").length == 1) {
                    const filter1Val = $("#InviteesListFilter1").length == 1 ? $("#InviteesListFilter1").val() : "";
                    const filter1FieldId = $("#Filter1TaskItemFieldId").val();
                    requestData.filter1Val = filter1Val;
                    requestData.filter1FieldId = filter1FieldId;
                }

                if ($("#Filter2TaskItemFieldId").length == 1) {
                    const filter2Val = $("#InviteesListFilter2").length == 1 ? $("#InviteesListFilter2").val() : "";
                    const filter2FieldId = $("#Filter2TaskItemFieldId").val();
                    requestData.filter2Val = filter2Val;
                    requestData.filter2FieldId = filter2FieldId;
                }

                if ($("#Filter3TaskItemFieldId").length == 1) {
                    const filter3Val = $("#InviteesListFilter3").length == 1 ? $("#InviteesListFilter3").val() : "";
                    const filter3FieldId = $("#Filter3TaskItemFieldId").val();
                    requestData.filter3Val = filter3Val;
                    requestData.filter3FieldId = filter3FieldId;
                }

                YouLi.Common.Get({
                    url: '/trip/updateinviteeslistforsearch',
                    params: requestData,
                }).then(data => {
                    $("#invitees-section-going-list").html(data.inviteesListHtml);
                });

            };
            
            $(function () {

                $(document).on("change", "#InviteesListCategory", function () {
                    if ($(this).val() == "") {
                        $("#InviteesListFilters").html(""); // remove the filters when no category is selected
                    }
                    else {
                        RefreshFiltersForCategory($(this).val());    
                    }
                    SearchInvitees();
                });

                $(document).on("keypress", "#InviteesListSearchTerm", function (e) {
                    if (e.keyCode == 13)
                        SearchInvitees();
                });

                $(document).on("click", "#SearchButton", function () {
                    SearchInvitees();
                });
            });


        }(YouLi.Trip.Invitees ? YouLi.Trip.Invitees : {}));
    }(YouLi.Trip ? YouLi.Trip : {}));
}(YouLi ? YouLi : {}));